
import { defineComponent, PropType, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { RPT } from '@/core/types/rp.types'
import { rp } from '@/core/realisations/rp.realisation'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<RPT>,
            required: true,
        },
    },
    setup(props) {
        const state = reactive({
            is_rpp_loading: false,
            is_rpk_loading: false,
        })

        const saveFile = (content: File | Blob, file_name: string) => {
            const download_url = window.URL.createObjectURL(content)

            const link = document.createElement('a')
            link.href = download_url
            link.setAttribute('download', file_name)
            document.body.appendChild(link)
            link.click()
            link.remove()
        }

        const exportRPPList = async () => {
            try {
                state.is_rpp_loading = true

                const response = await rp.exportRPPListExcel(props.item.id)
                saveFile(response, `Список РПП (ID: ${props.item.id}).xlsx`)
            } catch (error) {
                console.error(error)
            } finally {
                state.is_rpp_loading = false
            }
        }

        const exportRPKList = async () => {
            try {
                state.is_rpk_loading = true

                const response = await rp.exportRPKListExcel(props.item.id)
                saveFile(response, `Список РПК (ID: ${props.item.id}).xlsx`)
            } catch (error) {
                console.error(error)
            } finally {
                state.is_rpk_loading = false
            }
        }

        const formatDate = (dateStr: string) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            return dateFirst.split('-').reverse().join('.')
        }

        return { state, exportRPPList, exportRPKList, formatDate }
    },
})
